<template class="has-navbar-fixed-top">
  <div id="styleguide">

    <a @click="toggleNavLeft()" class="is-fixed-button-top-left is-fixed-top button is-primary-grad-circle is-circle has-shadow-dark">
     <i v-if="isNavLeftOpen" class="ri-close-line"></i> 
     <i v-else class="ri-chat-1-line"></i> 
    </a>

    <a @click="toggleNavRight()" class="is-fixed-button-top-right is-fixed-top button is-primary-grad-circle is-circle has-shadow-dark">
      <i v-if="isNavRightOpen" class="ri-close-line"></i> 
      <i v-else class="ri-user-line"></i> 
    </a>
    
    <section class="is-fullheight">
      <!--
      <Navigation></Navigation>
      -->
      <div class="has-page-background">

        <div id="leftSideNav" class="left-side-nav has-content-background-gradient">
          <div style="position: relative;">
            <div class="sideNavControlOpen" @click="openNav()">Open</div>
          </div>
          <a href="javascript:void(0)" class="closebtn" @click="closeNav()">&times;</a>
          <a href="javascript:void(0)" @click="closeNavPush()">&times; Push</a>
          <a href="#">About</a>
          <a href="#">Services</a>
          <a href="#">Clients</a>
          <a href="#">Contact</a>
        </div>

        <div id="main" class="has-padding-lg">
          <div>
          <!--
          <div class="container content">
          -->
            <nav class="level is-mobile navbar has-page-background">
              <div class="level-left">
                <div class="level-item">
                  <b-tooltip :label="$t('navigation.back')" position="is-bottom" type="is-black">
                    <router-link to="/posts" class="button is-info is-outlined is-rounded has-margin-right-10">
                      <i class="ri-arrow-left-line"></i> Back
                    </router-link>
                  </b-tooltip>&nbsp;|&nbsp;
                  <div class="has-margin-right-10">Page Title</div>
                  <b-dropdown aria-role="list">
                    <button class="button is-brand is-rounded" slot="trigger">
                        <span>Test</span>
                        <i class="ri-arrow-down-s-fill"></i>
                    </button>
                    <b-dropdown-item aria-role="listitem">Action</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem">Another action</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem">Something else</b-dropdown-item>
                </b-dropdown>
                </div>
              </div>
              <div class="level-left">
                <b-tooltip :label="$t('navigation.my-activity')" position="is-bottom" type="is-black">
                  <router-link to="/activity">
                    <div class="button is-brand has-padding-10 has-margin-left-10">
                      <i class="ri-apps-line has-text-success"></i>
                    </div>
                  </router-link>
                </b-tooltip>
                <b-tooltip :label="$t('navigation.my-activity')" position="is-bottom" type="is-black">
                  <router-link to="/activity">
                    <div class="button is-brand has-padding-10 has-margin-left-10">
                      <i class="ri-dashboard-line has-text-success"></i>
                    </div>
                  </router-link>
                </b-tooltip>
                <b-tooltip :label="$t('navigation.my-activity')" position="is-bottom" type="is-black">
                  <router-link to="/activity">
                    <div class="button is-brand has-padding-10 has-margin-left-10">
                      <i class="ri-more-2-fill has-text-success"></i>
                    </div>
                  </router-link>
                </b-tooltip>
                <b-tooltip :label="$t('navigation.my-post')" position="is-bottom" type="is-black">
                  <router-link to="/post" class="button is-primary-grad is-rounded is-fullwidth  has-margin-left-10">
                    <i class="ri-time-line"></i>&nbsp;Post
                  </router-link>
                </b-tooltip>
              </div>
            </nav>
            <hr />
            
            <br />
            <span @click="openNavPush()">Push</span>

            <div>
              <i class="ri-time-line has-text-success"></i> Test, <i class="ri-table-fill has-text-primary"></i> slkfjklsd <i class="ri-radar-fill has-text-info"></i> jkflsk <i class="ri-send-plane-fill has-text-success"></i> lkjasld;kfj asdf <a href="#"><i class="ri-twitter-fill ri-xl has-text-primary"></i></a> . <a href="#"><i class="ri-twitch-fill ri-xl has-text-primary"></i></a> <a href="#"><i class="ri-twitter-fill ri-xl has-text-primary"></i></a>
            </div>
            <div v-if="userProfile.role == 'admin'">
              <div class="tabs">
                <ul>
                  <li class="is-active"><a>Pictures</a></li>
                  <li><a>Videos</a></li>
                  <li><a>Documents</a></li>
                </ul>
              </div>

              <div v-if="pendingPostsAll.length">
                <div
                  v-for="pendingPostAll in filterPosts"
                  v-bind:key="pendingPostAll.value"
                >
                  <div class="columns">
                    <div class="column">
                      <div class="item-content">
                        <span class="is-size-5">
                          <a @click="detailPost(pendingPostAll)">{{ pendingPostAll.title }}</a>&nbsp;
                        </span>
                        <span class="has-text-grey-light is-size-7">
                          <i>{{ pendingPostAll.createdOn | formatDate }}</i>
                        </span>
                        <span v-if="pendingPostAll.imageUrl">
                          &nbsp;<i class="ri-image-line has-text-success"></i>  
                          <!--<img :src="pendingPostAll.imageUrl" :alt="pendingPostAll.title" style="width: 100%" />-->
                        </span> 
                        <div class="has-margin-bottom-10">
                          {{ pendingPostAll.content | trimLength }}
                        </div>
                        
                        <div class="control has-margin-bottom-10">
                          <b-taglist attached>
                            <b-tag type="is-dark">Status:</b-tag>
                            <b-tag v-if="pendingPostAll.status == 'approved'" type="is-success">Approved</b-tag>
                            <b-tag v-else type="is-info">Pending</b-tag>
                          </b-taglist>
                        </div>

                        <div class="buttons">
                          <a
                            v-if="pendingPostAll.status == 'pending'"
                            @click="approvePost(pendingPostAll.id)" 
                            class="button is-success is-small"
                          >
                            
                            <i class="ri-check-line"></i>
                            <span>&nbsp;Approve</span>
                          </a>
                          <a
                            @click="deletePostModal(pendingPostAll)"
                            class="button is-danger is-small"
                          >Delete</a> 
                        </div>
                      </div>
                    </div>
                    <div class="column is-2">
                      <div class="item-content has-text-right">
                        <div v-if="currentUser && pendingPostAll.userId == currentUser.uid">
                          <b-dropdown aria-role="list" position="is-bottom-left">
                            <button class="button is-info is-outlined is-small" slot="trigger">
                              <i class="ri-more-2-fill ri-lg"></i> 
                            </button>
                            <a>
                              <b-dropdown-item aria-role="listitem" class="has-text-warning">Edit</b-dropdown-item>
                            </a>
                            <a>
                              <b-dropdown-item aria-role="listitem" class="has-text-danger">Delete</b-dropdown-item>
                            </a>
                          </b-dropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
              <div v-else>
                <p>Sorry, no results - please try again.</p>
              </div>
            </div>
            <div v-else>
              <p>Unauthoried Page.</p>
            </div>
          </div>
        </div>
       
        <div id="rightSideNavSub" class="right-side-nav-sub">
          <div class="sideRightNavControlOpen" @click="openRightNavPush()">Open</div>
          <hr />
          <a href="javascript:void(0)" class="closebtn" @click="closeRightNavPush()">&times;</a>

          <hr />
          <div class="has-text-centered">
            <br />
            {{ userProfile.name }} . 203
            <br />
            Bounties
            <hr />
            <a class="button is-brand">Pop</a>
            <h5>Activity</h5>

          </div>
        </div>
      </div>
      <transition name="fade">
        <a @click="scrollToTop()" id="btn-scroll-to-top">
          <div class="menu-fixed has-shadow">
            <div class="has-background-dark has-padding">
              <i class="ri-arrow-up-line"></i> 
            </div>
          </div>
        </a>
      </transition>
      <b-loading :active.sync="isLoading" :can-cancel="true">
        <div id="spinner"></div>
      </b-loading>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

import Navigation from '@/components/Navigation'

export default {
  data() {
    return {
      pendingPostAll: {
        title: "",
        content: "",
        website: "",
        imageUrl: "",
        score: "",
        status: "",
      },
      showCommentModal: false,
      fullPost: {},
      fullEditPost: {},
      postComments: [],
      isLoading: false,
      isFullPage: "",
      postFilterKey: "all",
      gravity: "",
      score: "",

      isNavLeftOpen: false,
      isNavRightOpen: false,

      //showLoginModal: false
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "pendingPostsAll"]),

    filterPosts() {
      return this[this.postFilterKey];
    },

    all() {
      this.isLoading = false;
      return this.pendingPostsAll;
    },
  },

  beforeMount() {
    this.isLoading = true;

    window.onscroll = function() {scrollFunction()};
    function scrollFunction() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        document.getElementById("btn-scroll-to-top").style.display = "block";
      } else {
        document.getElementById("btn-scroll-to-top").style.display = "none";
      }
    }
  },

  //methods: mapMutations(['switchTheme']),
  methods: {

    toggleNavLeft() {
      if (this.isNavLeftOpen != true){
        this.openNavPush();
        this.isNavLeftOpen= true;
      } else {
        console.log("toggleNavLeft false");
        this.closeNavPush();
        this.isNavLeftOpen= false;
      }
    },
    toggleNavRight() {
      if (this.isNavRightOpen != true){
        this.openRightNavPush();
        this.isNavRightOpen = true;
      } else {
        console.log("toggleNavLeft false");
        this.closeRightNavPush();
        this.isNavRightOpen = false;
      }
    },
    openNav() {
      document.getElementById("leftSideNav").style.width = "250px";
      document.getElementById("main").style.marginLeft = "40px";
    },
    closeNav() {
      document.getElementById("leftSideNav").style.width = "40px";
      document.getElementById("main").style.marginLeft = "40px";
    },
    openNavPush() {
      document.getElementById("leftSideNav").style.width = "250px";
      document.getElementById("main").style.marginLeft = "250px";
    },
    closeNavPush() {
      document.getElementById("leftSideNav").style.width = "40px";
      document.getElementById("main").style.marginLeft = "40px";
    },

    //Right
    openRightNav() {
      document.getElementById("rightSideNavSub").style.width = "250px";
      document.getElementById("main").style.marginRight = "0px";
    },
    closeRightNav() {
      document.getElementById("rightSideNavSub").style.width = "0px";
      document.getElementById("main").style.marginRight = "0px";
    },
    openRightNavPush() {
      document.getElementById("rightSideNavSub").style.width = "250px";
      document.getElementById("main").style.marginRight = "250px";
    },
    closeRightNavPush() {
      document.getElementById("rightSideNavSub").style.width = "0px";
      document.getElementById("main").style.marginRight = "0px";
    },
  },
  
  snackbarSuccess() {
    this.$snackbar.open({
      duration: 4000,
      message: "Your post has been updated!",
      type: "is-primary",
      position: "is-bottom",
      actionText: "Return to posts page",
      class: "has-background-info",
      queue: false,
      onAction: () => {
        this.$router.push("/posts");
      }
    });
  },
  snackbarError() {
    this.$snackbar.open({
      duration: 4000,
      message: "Oh oh, looks like there a sever issue!",
      type: "is-info",
      position: "is-bottom",
      actionText: "Return to Dashboard",
      queue: false,
      onAction: () => {
        this.$router.push("/dashboard");
      }
    });
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },

    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    }
  },
  components: {
    Navigation
  }
};
</script>

<style>
  .is-fixed-button-top-left {
    position: fixed !important; /* overwrite button - relative */
    top: 20px;
    left: 20px;
    z-index: 1000;
  }

  .is-fixed-button-top-right {
    position: fixed !important; /* overwrite button - relative */
    top: 20px;
    right: 20px;
    z-index: 1000;
  }

  .sideNavControlOpen {
    position: absolute;
    right: -20px;
    z-index: 20;
  }
  .sideRightNavControlOpen {
    position: absolute;
    left: -20px;
    z-index: 20;
  }

  .right-side-nav-sub {
    height: 100%; /* 100% Full-height */
    width: 0px; /* 0 width - change this with JavaScript */
    position: fixed; /* Stay in place */
    z-index: 1; /* Stay on top */
    top: 0; /* Stay at the top */
    right: 0px;
    background-color: rgb(40, 37, 49); /* Black*/
    overflow-x: hidden; /* Disable horizontal scroll */
    padding-top: 60px; /* Place content 60px from the top */
    transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
  }


  /* The side navigation menu */
  .left-side-nav {
    height: 100%; /* 100% Full-height */
    width: 40px; /* changes this with JavaScript */
    position: fixed; /* Stay in place */
    z-index: 1; /* Stay on top */
    top: 0; /* Stay at the top */
    left: 0;
    overflow-x: hidden; /* Disable horizontal scroll */
    padding-top: 60px; /* Place content 60px from the top */
    transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
  }

  /* The navigation menu links */
  .left-side-nav a {
    padding: 8px 8px 8px 32px;
    text-decoration: none;
    color: #818181;
    display: block;
    transition: 0.3s;
  }

  /* When you mouse over the navigation links, change their color */
  .left-side-nav a:hover {
    color: #f1f1f1;
  }

  /* Position and style the close button (top right corner) */
  .left-side-nav .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
  }

  /* Style page content - use this if you want to push the page content to the right when you open the side navigation */
  #main {
    transition: margin-left .5s, margin-right .5s;
    margin-left: 40px;

    margin-right: 0px;
    /*
    transition: margin-right .5s;
    margin-right: 250px;
    */
    /*
    padding: 20px;
    */
  }

  /* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
  @media screen and (max-height: 450px) {
    .side-nav {padding-top: 15px;}
    .side-nav a {font-size: 18px;}
  }
</style>